export default __webpack_public_path__ + "static/media/spark_55.b3573832.png";